import React, { useState, useEffect, useContext } from "react";
import { Header, Grid, Button } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import PhotoWidgetDropzone from "./PhotoWidgetDropzone";
import PhotoWidgetCropper from "./PhotoWidgetCropper";
import { RootStoreContext } from "../../stores/rootStore";

const PhotoUploadWidget = () => {
  const [files, setFiles] = useState<any[]>([]);
  const [img, setImage] = useState<Blob | null>(null);

  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { uploadLogo, btUploadLogo, image } = rootStore.companyStore;

  useEffect(() => {
    return () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    };
  });
  return (
    <div className="configurationContent">
      <Grid>
        <Grid.Column width={4}>
          <Header color="black" sub content="Paso 1 - Arrastrar imagen" />
          <PhotoWidgetDropzone setFiles={setFiles} />
        </Grid.Column>
        <Grid.Column width={1} />
        <Grid.Column width={4}>
          <Header sub color="black" content="Paso 2 - Reajustar imagen" />
          {files.length > 0 ? (
            <PhotoWidgetCropper
              setImage={setImage}
              imagePreview={files[0].preview}
            />
          ) : (
            <PhotoWidgetCropper setImage={setImage} imagePreview={image!} />
          )}
        </Grid.Column>
        <Grid.Column width={1} />
        <Grid.Column width={4}>
          <Header sub color="black" content="Paso 3 - Vista previa" />
          <div
            className="img-preview"
            style={{ minHeight: "200px", overflow: "hidden" }}
          />
        </Grid.Column>
      </Grid>
      <br />
      <Button
        primary
        loading={btUploadLogo}
        disabled={btUploadLogo}
        content="Guardar"
        onClick={() => {
          uploadLogo(img!);
        }}
      />
    </div>
  );
};

export default observer(PhotoUploadWidget);
